const rawHealioSpaceAPIURL = process.env.HEALIO_API_URL;

export const LOCAL_PROXY_PREFIX = '/local-api';

const isLocalHttpsApi = (url: string | undefined): boolean => {
  if (!url || url.startsWith('/')) {
    return false;
  }

  try {
    const parsed = new URL(url);
    const isLocalHost = parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1';

    return parsed.protocol === 'https:' && isLocalHost;
  } catch (error) {
    console.warn('Failed to parse HEALIO_API_URL; assuming non-local target.', error);

    return false;
  }
};

export const healioSpaceAPIURL = isLocalHttpsApi(rawHealioSpaceAPIURL)
  ? LOCAL_PROXY_PREFIX
  : rawHealioSpaceAPIURL;

export const healioSpaceAPIRawURL = rawHealioSpaceAPIURL;
